import { UserRole } from "../interfaces/user";
import { useUser } from "./use-user";

const adminRoutes = [
  "/users",
  "/users/:id",
  "/users/create",
  "/settings/users",
  "/settings/users/:id",
  "/settings/users/create",
  "/settings/products",
  "/settings/products/:id",
  "/settings/products/create",
  "/settings",
];

const useAccess = () => {
  const { user } = useUser();
  const hasRouteAccess = (route: string) => {
    if (!user) {
      return false;
    }

    if (
      user.role !== UserRole.Admin &&
      user.role !== UserRole.SuperAdmin &&
      adminRoutes.includes(route)
    ) {
      return false;
    }

    return true;
  }

  return { hasRouteAccess };
};

export default useAccess;